module.exports = __webpack_public_path__ + "img/event_pc_tab_02.88be72e0.png";